<script setup lang="ts">
const app = useNuxtApp()
const route = useRoute()
const storeIndex = useStoreIndex()
const storeArticleList = useStoreArticleList()

definePageMeta({
  layout: 'layout-side-default',
  middleware: defineNuxtRouteMiddleware((to) => {
    const app = useNuxtApp()
    const storeIndex = useStoreIndex()
    storeIndex.init()
    const reqYear = app.$anyToInteger(to.params.year, null)
    if (reqYear && reqYear !== storeIndex.state.displayYear) {
      return navigateTo(`/schedule/${storeIndex.state.displayYear}`, { redirectCode: 301 })
    }
  }),
  validate: async (route) => {
    const app = useNuxtApp()
    return app.$anyToInteger(route.params.year, null) ? true : false
  },
})

const baseTitle = '展覧会スケジュール'
let headTitle = ''
let headDescription = ''

let year = 2025
let areaCategories = []

const setHead = () => {
  headTitle = `${year}年の${baseTitle}`
  headDescription = `${headTitle}がひとめで分かります。主要な美術館・博物館・ミュージアムの年間スケジュールがずらり、旅行の予定にも！`
  // ぱんくず作成
  storeIndex.setBreadCrumbs([
    {
      text: baseTitle,
      disabled: false,
      to: { path: '/schedule' },
    },
  ])

  const headInput = app.$makeMeta({
    title: headTitle,
    description: headDescription,
  })
  useHead(headInput)
}

const initPage = async () => {
  year = app.$anyToInteger(route.params.year, null)
  if (!year) {
    showError({ statusCode: 404 })
    return
  }

  const [_resSite, _resMaster, resCategory] = await Promise.all([
    storeIndex.fetchSite(),
    storeIndex.fetchMaster(),
    storeArticleList.fetchCategories('event'),
  ])
  const eventCats = resCategory.data.Categories
  //  全エリアカテゴリ取得
  areaCategories = app.$getChildCategoriesBySlug(eventCats, 'root_schedule_area')
}
await initPage()
setHead()
</script>

<template>
  <div class="p-schedule">
    <h1 class="c-heading_page">
      {{ year }}年の展覧会スケジュール
    </h1>
    <div class="c-heading_description is-gray">
      ここでは、エリア別に主要なミュージアムの年間スケジュールをご紹介します。
    </div>

    <div class="p-schedule_toc">
      <div class="p-schedule_toc_area">
        <nuxt-link
          v-for="area in areaCategories"
          v-bind:key="area.id"
          v-bind:to="{ name: 'schedule-year-slug', params: { year: year, slug: area.category_slug } }"
        >
          {{ area.name }}
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<style lang = "scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";

.p-schedule {
  position: relative;

  &_toc {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid var(--g_color_border_gray);

    &_area {
      display: flex;
      flex-wrap: wrap;
      margin-top: 32px;

      a {
        display: inline-block;
        height: 48px;
        margin-right: 17px;
        margin-bottom: 20px;
        padding: 0 10px;
        transition: 0.3s;
        border: 1px solid var(--g_color_border_gray);
        color: var(--color_text_base);
        font-size: 16px;
        line-height: 46px;

        &:hover {
          transition: none;
          background-color: var(--color_hover_grey);
          text-decoration: none;
        }

        @include responsive.mq_down(sp) {
          height: 38px;
          margin-bottom: 10px;
          font-size: 14px;
          line-height: 36px;
        }
      }
    }
  }
}
</style>
